export { AgentIndicator } from '../../static/icons/AgentIndicator';
export { BotIndicator } from '../../static/icons/BotIndicator';
export { ChatIcon } from '../../static/icons/ChatIcon';
export { CheckboxIcon } from '../../static/icons/CheckboxIcon';
export { ChevronDown } from '../../static/icons/ChevronDown';
export { ChevronRight } from '../../static/icons/ChevronRight';
export { ClockIcon } from '../../static/icons/ClockIcon';
export { CloseIcon } from '../../static/icons/CloseIcon';
export { EndChatIcon } from '../../static/icons/EndChatIcon';
export { FeedbackIcon} from '../../static/icons/FeedbackIcon';
export { MenuIcon } from '../../static/icons/MenuIcon';
export { MuteIcon } from '../../static/icons/MuteIcon';
export { NewMessageIcon } from '../../static/icons/NewMessageIcon';
export { RadioIcon } from '../../static/icons/RadioIcon';
export { RatingStar, RatingStarIcon } from '../../static/icons/RatingStar';
export { ReceiptIcon } from '../../static/icons/ReceiptIcon';
export { RingIcon } from '../../static/icons/RingIcon';
export { RingIconOld } from '../../static/icons/RingIconOld';
export { SendIcon } from '../../static/icons/SendIcon';
export { ThemeIcon } from '../../static/icons/ThemeIcon';
export { ThumbsDownIcon } from '../../static/icons/ThumbsDownIcon';
export { ThumbsUpIcon } from '../../static/icons/ThumbsUpIcon';
export { UnmuteIcon } from '../../static/icons/UnmuteIcon';
export { UserIcon } from '../../static/icons/UserIcon';
